/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject} from '@angular/core';

import template from './library-creative-list-page.component.html';
import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../common/controller/signal-admin-resource-list-state';
import {CreativeBulkActionService} from '../creative/creative-bulk-action.service';
import {asUrlGroupList, asUrlList} from '../creative/creative-url-utils';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';
import {LibraryCreativeApiService, LibraryCreativeModel} from './library-creative-api.service';
import {AdvertisingSharedModule} from '../advertising/advertising-shared.module';

@Component({
  standalone: true,
  imports: [AdvertisingSharedModule],
  selector: 'adn-library-creative-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LibraryCreativeListPageComponent implements OnInit {
  readonly itemStateName = 'app.adv.library-creatives.library-creative';
  readonly layoutItemStateName = 'app.adm.layouts.layout';

  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'Layout', label: 'layout'},
    {param: '', label: 'URLs', sortable: false},
    {param: 'width', label: 'dimensions', sortable: false},
    {param: 'updateTime'},
    {param: '', label: 'targeting', sortable: false}
  ];

  readonly list = inject(SignalAdminResourceListStateFactory).create<LibraryCreativeModel>(
    inject(LibraryCreativeApiService),
    {listId: 'fullLibraryCreativeList', baseTable: 'libraryCreative'},
    inject(DestroyRef)
  );

  private readonly permissions = inject(LocalUserPermissions);
  private readonly api = inject(LibraryCreativeApiService);
  private readonly creativeBulkActionService = inject(CreativeBulkActionService);

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  layoutLinkDisabled(): boolean {
    return this.permissions.getAllVisPermissions().MANAGE_LAYOUTS !== true;
  }

  constraintUrls(creative: any): string[] {
    return asUrlList(creative?.constraintsToUrls);
  }

  assetHtmlUrlGroups(creative: any): string[][] {
    return asUrlGroupList(creative?.assetHtmlUrls);
  }

  ngOnInit(): void {
    this.list.load();
  }

  openBulkActions(): void {
    this.creativeBulkActionService.createBulkAction({
      bulkSelection: this.list.selected(),
      miscBulkAction: (modal: any, controller: any, items: Partial<LibraryCreativeModel>[]) => {
        this.api.saveMany(items).subscribe({
          next: () => {
            modal.close();
            this.list.deselectAll();
            this.list.load();
          },
          error: () => {
            controller.form = controller.form || {};
            controller.form.bulkError = true;
          }
        });
      }
    })();
  }
}
